import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '../useApiMutation';
import { apiPatch, operationsClient } from '@/lib/api';
import { appointmentFormEndpoints } from '@/lib/api/endpoints';
import { formSubmissionKeys } from '@/lib/queryKeys';
import type { FormSubmission, UpdateFormSubmissionDto } from '@/types/appointmentForm';
import { formSubmissionErrorMessage } from './formSubmissionErrors';

interface Variables {
  id: string;
  dto: UpdateFormSubmissionDto;
}

export function useUpdateFormSubmission(appointmentId: string) {
  const queryClient = useQueryClient();
  return useApiMutation<FormSubmission, Variables>({
    mutationFn: ({ id, dto }) =>
      apiPatch<FormSubmission, UpdateFormSubmissionDto>(
        operationsClient,
        appointmentFormEndpoints.submission(id),
        dto,
      ),
    onSuccess: (_data, { id }) => {
      void queryClient.invalidateQueries({
        queryKey: formSubmissionKeys.byAppointment(appointmentId),
      });
      void queryClient.invalidateQueries({ queryKey: formSubmissionKeys.detail(id) });
      toast.success('Form saved');
    },
    showErrorToast: false,
    onError: (error) => {
      toast.error(formSubmissionErrorMessage(error));
    },
  });
}
